<template>
  <div class="main-side-bar-button" @click="onClick" :class="mainClass">
    <slot></slot>
    <i class="icon s-icon-arrow-right"/>
  </div>
</template>

<script>
export default {
    components: {},
    props: {
        routeName: {
            type: String,
            default: ''
        },
        routeNameMatch: {
            type: String,
            default: ''
        },
        forceOrganization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
    computed: {
        isActive() {
            if (!this.routeNameMatch) return false
            let currentRouteName = this.$route ? this.$route.name : ''
            if (!currentRouteName) return false
            let a = this.routeNameMatch.split(';')
            return a.some(item => {
                return currentRouteName.indexOf(item) >= 0
            })
        },
        mainClass() {
            return this.isActive ? 'active' : 'not-active'
        }
    },
    methods: {
        onClick() {
            this.$gotoRoute(this.routeName, null, this.forceOrganization)
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.main-side-bar-button
    position relative
    margin 0 12px
    box-sizing border-box
    width auto
    min-height 18px
    color black
    display flex
    font-family roboto
    font-weight bold
    font-size 16px
    align-items center
    padding 16px 12px 16px 20px
    justify-content space-between
    user-select none
    cursor pointer
    // basic-button(black, null, null, 4px)
    // box-shadow 0 0 0 rgba(0, 0, 0, 0)
    // overflow visible

    &.small
        padding 8px 8px 8px 20px
        font-size 14px
        font-weight normal

    & > *
        z-index 1000

    span
        transition color 0.15s

    &::before
        position absolute
        top 0
        // left -32px
        left 0
        content ''
        border-radius 6px
        background-color $color-primary
        opacity 0
        width 100%
        height 100%
        transition all 0.35s cubic-bezier(.41,2.24,.61,1)
        // transition all 0.35s ease-out
        // transition transform 0.35s cubic-bezier(.41,2.24,.61,1)
        // transition box-shadow 0.35s cubic-bezier(.41,2.24,.61,1)
        z-index 1
        transform scale(0.95)

    &:hover
        z-index 10

        &::before
            // box-shadow 0 4px 8px rgba(0, 0, 0, 0.4)
            box-shadow 0 10px 8px -8px rgba(0, 0, 0, 0.4)
            transform scale(1.035)

    &.active
    &:hover
        &::before
            top 0
            left 0
            background-color $color-primary
            opacity 1
            transform scale(1)

    &.active
    &:hover
        color white

        .icon
            opacity 1

    &:not(first-child)
        margin-top 2px

    .icon
        color $color-primary-text
        opacity 0
        font-size 10px
        font-weight normal
        transition all 0.125s

</style>



// WEBPACK FOOTER //
// src/modules/app/components/SideBarButton.vue